import React from 'react';

export const Show = ({ children, fallback = null, when }) => {
  if (when) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return <React.Fragment>{fallback}</React.Fragment>;
};
